<template>
  <title-component
    :text="text"
    :background-image="true"
    :info="gameWeekTitle"
    :caption="gameWeekDateRange"
  />
</template>

<script>
import GameWeek from '@/models/GameWeek/gameWeek';
import TitleComponent from '@/components/Title.vue';

export default {
  name: 'GameTitle',
  components: {
    TitleComponent,
  },
  props: {
    text: {
      type: String,
      default: '',
    },
    gameWeek: {
      type: GameWeek,
      default: null,
    },
  },
  computed: {
    gameWeekTitle() {
      return this.gameWeek?.title();
    },
    gameWeekDateRange() {
      return this.gameWeek?.dateRange();
    },
  },
};
</script>
